'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

const baseUrl = 'https://www.villatravellers.com/';

function GenerateBreadcrumbs() {
  const paths = usePathname();
  const pathNames = paths.split('/').filter((path) => path);

  const jsonLd = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: baseUrl,
      },
      ...pathNames.map((link, index) => ({
        '@type': 'ListItem',
        position: index + 2,
        name: link[0].toUpperCase() + link.slice(1),
        item: encodeURI(`${baseUrl}${pathNames.slice(0, index + 1).join('/')}`),
      })),
    ],
  };

  return (
    <Script
      id="breadcrumbs-json-ld"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export default GenerateBreadcrumbs;
